import { http } from "../http/Http";
import { Task } from "../models/Task";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { TaskDoneDetails } from "../models/TaskDoneDetails";

export class TaskService {

    getTasksByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<Task[]>> => {
        const { data } = await http.post<ServiceResponse<Task[]>>("Task/GetByFilters", apiQueryFilter);
        return data;
    };

    getTask = async (id: number): Promise<Task> => {
        const { data } = await http.get<Task>(("Task/GetById/" + id.toString()));
        return data;
    };

    addTask = async (task: Task): Promise<Task> => {
        const { data } = await http.post<Task>("Task/Post", task);
        return data;
    };

    updateTask = async (task: Task): Promise<ServiceResponse<Task>> => {
        const { data } = await http.put<ServiceResponse<Task>>("Task/Put", task);
        return data;
    };

    doneTask = async (taskDoneDetails: TaskDoneDetails): Promise<ServiceResponse<Task>> => {
        const { data } = await http.put<ServiceResponse<Task>>("Task/Done", taskDoneDetails);
        return data;
    };

    saveTask = async (taskDoneDetails: TaskDoneDetails): Promise<ServiceResponse<Task>> => {
        const { data } = await http.put<ServiceResponse<Task>>("Task/Save", taskDoneDetails);
        return data;
    };

    groupByField = async (groupBy: { Field: string, IsCustom: boolean, DataType: string | null, ApiQueryFilter: GetByFiltersArguments }): Promise<any> => {
        const { data } = await http.post<any>("Task/GroupByField", groupBy);
        return data;
    };

}